import { render, staticRenderFns } from "./mind-map-node.vue?vue&type=template&id=f61c7228&scoped=true&"
import script from "./mind-map-node.vue?vue&type=script&lang=js&"
export * from "./mind-map-node.vue?vue&type=script&lang=js&"
import style0 from "./mind-map-node.vue?vue&type=style&index=0&id=f61c7228&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f61c7228",
  null
  
)

export default component.exports